import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "select"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    const options = Array.from(this.selectTarget.options)

    options.forEach((option) => {
      if (!option.value) return
      const text = option.text.toLowerCase()
      const match = query.length === 0 || text.includes(query)
      option.hidden = !match
      option.disabled = !match
    })
  }
}
